module.exports = __webpack_public_path__ + "img/ROBUR.7f1db6b5.avif";